import type { Transition, Variants } from 'framer-motion'

const easeOut: Transition['ease'] = [0.42, 0, 0.58, 1]

export const fadeUp: {
  variants: Variants
  transition: Transition
} = {
  variants: {
    initial: { opacity: 0, y: 40, scale: 0.95 },
    animate: { opacity: 1, y: 0, scale: 1 },
  },
  transition: {
    duration: 0.6,
    ease: easeOut,
  },
}

export const fadeLeft: {
  variants: Variants
  transition: Transition
} = {
  variants: {
    initial: { opacity: 0, x: -60, scale: 0.9 },
    animate: { opacity: 1, x: 0, scale: 1 },
  },
  transition: {
    duration: 0.6,
    ease: easeOut,
  },
}

export const fadeRight: {
  variants: Variants
  transition: Transition
} = {
  variants: {
    initial: { opacity: 0, x: 60, scale: 0.9 },
    animate: { opacity: 1, x: 0, scale: 1 },
  },
  transition: {
    duration: 0.6,
    ease: easeOut,
  },
}

export const staggerContainer: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1,
    },
  },
}

export const scaleIn: {
  variants: Variants
  transition: Transition
} = {
  variants: {
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1 },
  },
  transition: { duration: 0.6, ease: easeOut },
}

export const cardFadeUp: {
  variants: Variants
  transition: Transition
} = {
  variants: {
    initial: { opacity: 0, y: 40, scale: 0.95 },
    animate: { opacity: 1, y: 0, scale: 1 },
  },
  transition: {
    duration: 0.6,
    ease: easeOut,
  },
}

export const slideUpBounce: {
  variants: Variants
  transition: Transition
} = {
  variants: {
    initial: {
      opacity: 0,
      y: 30,
      scale: 0.95,
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        stiffness: 300,
        damping: 20,
      },
    },
  },
  transition: {
    duration: 0.6,
  },
}

export const fadeUpSmooth: {
  variants: Variants
} = {
  variants: {
    initial: {
      opacity: 0,
      y: 20,
      filter: 'blur(4px)',
    },
    animate: {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      transition: {
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1] as [number, number, number, number],
      },
    },
  },
}
